import React, { useState } from 'react'
import './AdBillingStyle.css'
import Button from '../../../components/Button/Button'
import SearchBar from '../../../components/SearchBar/SearchBar'
import Dropdown from '../../../components/Dropdown/Dropdown'
import Dropdownmenu from '../../../components/Dropdownmenu/Dropdownmenu'
import { useNavigate } from 'react-router-dom'
import Paginationarrow from '../../../components/Paginationarrow/Paginationarrow'
import Dorpwoncustom from '../../../components/Dorpwoncustom/Dorpwoncustom'

const AdBilling = () => {

    //dropdown
    const [Dropdownlist, setDropdownlist] = useState();
    const options = [
        {
            label: 'Working Professional',
            value: 'work'
        },
        {
            label: 'Student',
            value: 'student'
        },
    ];

    const navigate = useNavigate()

    const [viewdropdown, setviewdropdown] = useState()

    return (
        <div className='tableAdfixwidth'>
            <div>
                <h2 className='heading-2 mb6'>Billings</h2>
                <p className='text3'>Toal 52</p>
            </div>
            <div className={`commonTableWrapper ContainerTabForAllTabData`}>
                <div className='bodyDataForallUserdata'>
                    <div className="FaqUserFiltter flex-between">
                        <SearchBar placeholder={'Search here...'} className={'searchbardesign'} />
                        <div className="FilterButtonPast flex gap-10" >
                            <div className='dropdownbtnshow'>
                                <Dorpwoncustom isActive={Dropdownlist} setIsActive={setDropdownlist} placeholder={'Showing 10 of 32'} options={options} />
                            </div>
                            <Button name={'Filters'} src={'/assets/img/Filter list.png'} className={'filterbtn'} />
                        </div>
                    </div>
                    <div className={`CallHistoryTabledata mt20 fixgapbiling1`}>
                        <div className="outerdiv">
                            <table>
                                <thead>
                                    <tr className='headingTabletr'>
                                        <th> <div className='headingtablediv'>Issued to</div></th>
                                        <th> <div className='headingtablediv'>Issued on</div></th>
                                        <th> <div className='headingtablediv'>Invoice No.</div></th>
                                        <th>Description </th>
                                        <th>
                                            <div className='dropdownwrapper flex pointer' onClick={() => setviewdropdown(!viewdropdown)}>Status
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10.4534 4.77173H6.81926H3.54676C2.98676 4.77173 2.70676 5.4484 3.10343 5.84506L6.1251 8.86673C6.60926 9.35089 7.39676 9.35089 7.88093 8.86673L9.0301 7.71756L10.9026 5.84506C11.2934 5.4484 11.0134 4.77173 10.4534 4.77173Z" fill="#737373" />
                                                </svg>
                                                {/* <Dropdownmenu setviewdropdown={setviewdropdown} viewdropdown={viewdropdown}  /> */}
                                            </div>
                                        </th>

                                        <th><div className="headingtablediv">Delivered sessions</div></th>
                                        <th>Amount</th>
                                        <th>Invoice</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>

                        <div className="innerdiv">
                            <table>
                                <tbody>
                                    <tr >
                                        <td>
                                            <div className="tableBox">
                                                <div className='Adminprofileimageuser'>
                                                    <img src="/assets/img/usercard5.png" alt="" className='pointer' />
                                                </div>
                                                <div className='Namedetails'>
                                                    <h4 className='namelink mb-6 navigatetext' onClick={() => navigate('/Billingchart')}>Jayshree Roa</h4>
                                                    <p className="text2">Senior Finance Manager</p>
                                                </div>
                                            </div>
                                        </td>

                                        <td>
                                            <div className='tableBox'>
                                                <h4>27/03/2023</h4>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='tableBox'>
                                                <h4>#INV0034</h4>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='tableBox'>
                                                <h4>Executive PGP Interviews</h4>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='tableBox'>
                                                <div className='mentorProfilearea'>
                                                    <h4 className={`completed Statuscheck`}>Paid</h4>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="tableBox">
                                                <div className='dsblock'>
                                                    <h4>2</h4>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="tableBox">
                                                <h4 className='lightgreen'>INR 4,000.00</h4>
                                            </div>
                                        </td>

                                        <td>
                                            <div className="tableBox">
                                                <span className='downloadspan'>
                                                    <img src="/assets/img/download.png" alt="" className='downloadimg' />
                                                </span>
                                            </div>
                                        </td>

                                    </tr>
                                    <tr >
                                        <td>
                                            <div className="tableBox">
                                                <div className='Adminprofileimageuser'>
                                                    <img src="/assets/img/usercard5.png" alt="" className='pointer' />
                                                </div>
                                                <div className='Namedetails'>
                                                    <h4 className='namelink mb-6 navigatetext' onClick={() => navigate('/Billingchart')}>Jayshree Roa</h4>
                                                    <p className="text2">Senior Finance Manager</p>
                                                </div>
                                            </div>
                                        </td>

                                        <td>
                                            <div className='tableBox'>
                                                <h4>27/03/2023</h4>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='tableBox'>
                                                <h4>#INV0034</h4>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='tableBox'>
                                                <h4>Executive PGP Interviews</h4>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='tableBox'>
                                                <div className='mentorProfilearea'>
                                                    <h4 className={`Cancelled Statuscheck`}>Unpaid</h4>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="tableBox">
                                                <div className='dsblock'>
                                                    <h4>2</h4>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="tableBox">
                                                <h4 className='lightgreen'>INR 4,000.00</h4>
                                            </div>
                                        </td>

                                        <td>
                                            <div className="tableBox">
                                                <span className='downloadspan'>
                                                    <img src="/assets/img/download.png" alt="" className='downloadimg' />
                                                </span>
                                            </div>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* <div className="lodeemorebutton mt10">
                            <Button name={'Load More'} className={'BlueFillButton buttontext'} />
                        </div> */}
                </div>
            </div>

            {/* <Paginationarrow /> */}
        </div>
    )
}

export default AdBilling